import React,{useState ,useEffect} from 'react';
import "./footer.css"
import TopFooter from '../../assets/images/top-footer.svg'
import Logo from '../../assets/images/Mask group.png'
import Leaf from '../../assets/images/leaf-left.svg'
import { GetContact,GetContactUs } from '../../utils/api'

//icon
import Clock from '../../assets/icons/footer/clock.svg'
import Phone from '../../assets/icons/footer/phone.svg'
import Email from '../../assets/icons/footer/email.svg'


const Footer = () => {
    const [loading, setLoading] = useState(false)
    const [contactList, setContactList] = useState(false)
    const [contactUsList, setContactUsList] = useState(false)

    const getContactData = async()=>{
        setLoading(true)
        try {
            let data = await GetContact()
            setContactList(data.data)



            let dataUs = await GetContactUs()
            setContactUsList(dataUs.data)
            
        } catch (error) {
            
        } finally{
            setLoading(false)
        }
    }

    useEffect (() => {
        setTimeout(() => {
            getContactData()
        }, 3000);
    }, [])

    function convertToPersianNumbers(input) {
        if (input) {

            const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return input.replace(/\d/g, (digit) => persianDigits[digit]);
        }
    }
    return (
        <div>

            <div className='footer'>
                <div className='top-footer'>
                    <img src={TopFooter} />
                </div>
                <img src={Logo} className='logo-img' width={100}/>
                <img src={Leaf} className='leaf-img' />
                <div className='detail mx-auto'>
                    <p className='text-xs '>
                        اگر به دنبال تجربه‌های متنوع و جذاب در دنیای نوشیدنی‌ها هستید، ما برای شما تنوعی از نوشیدنی‌ها و مزه‌ها فراهم کرده‌ایم. از طعم‌های
                        فوق‌العاده قهوه‌های اسپرسو و لته‌؛ گرم و خوشمزه تا طعم‌های ترکیبی از میوه‌ها در نوشابه‌های ما، مطمئناً انتخابی برای هر سلیقه و فصلی پیدا خواهید کرد.
                    </p>
                    <div className='d-flex align-items-center justify-content-center gap-4 mt-5 flex-col-mobile contact-us'>
                        <h5 className='text-sm font-bold mb-0 ml-5 '>با ما در ارتباط باشید</h5>
                        <div className='d-flex align-items-center gap-2 item'>
                            <div className='d-flex align-items-center gap-2 flex-mobile-1'>


                                <div className='img-footer'>
                                    <img src={Clock} alt="" />

                                </div>
                                <h6 className='text-xs font-bold mb-0'>زمان پاسخگویی : </h6>
                            </div>
                            <h6 className='text-xs text-[#00a14b] mb-0 text-right flex-mobile-1'>{convertToPersianNumbers(contactUsList.timemobile)}</h6>
                        </div>
                        <div className='d-flex align-items-center gap-2 item'>
                            <div className='d-flex align-items-center gap-2 flex-mobile-1'>
                                <div className='img-footer'>
                                    <img src={Phone} alt="" />
                                </div>
                                <h6 className='text-xs font-bold mb-0'>شماره تماس : </h6>

                            </div>
                            <a  href={`tel:${contactUsList.phone}`} className=' flex-mobile-1'>
                            <h6 className='text-xs text-[#00a14b] mb-0 text-right'>{convertToPersianNumbers(contactUsList.phone)}</h6>
                            </a>
                        </div>
                        <div className='d-flex align-items-center gap-2 item'>
                            <div className='d-flex align-items-center gap-2 flex-mobile-1'>
                                <div className='img-footer'>
                                    <img src={Email} alt="" />

                                </div>
                                <h6 className='text-xs font-bold mb-0'>ایمیل : </h6>

                            </div>
                            <a  href={`mailto:${contactUsList.email}`}  className=' flex-mobile-1'>
                            <h6 className='text-xs text-[#00a14b] mb-0 text-right'>{convertToPersianNumbers(contactUsList.email)}</h6>
                            </a>
                        </div>
                    </div>

                </div>
                <div className='bottom-footer text-[10px] text-[#fff]'>
                    حق کپی رایت محفوظ می‌باشد، طراحی و پیاده سازی توسط خودمون

                </div>
            </div>
        </div>
    );
}

export default Footer;
